import { Component, forwardRef, Input } from '@angular/core';
import { AbstractControl, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from 'src/app/classes/base-control-value-accessor';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true,
    },
  ],
})

export class DropdownComponent extends BaseControlValueAccessor<any[]> {
  @Input() label : string;
  @Input() formControlName : string;
  @Input() options : any[];
  @Input() control: AbstractControl;
  @Input() fieldStyles: boolean = true;
  @Input() filter: boolean = false;
}